import React, { useState } from 'react';
import { createUserWithEmailAndPassword, sendEmailVerification } from 'firebase/auth';
import { useNavigate } from 'react-router-dom';
import { auth } from '../../firebase';
import { allowed_domains } from '../auth/allowedDomains';
import './Signup.css';

function isPasswordOk(pwd) {
  const pwdReqs = 'Password must be at least 8 characters, have 1 capital letter, and 1 number';
  if (pwd.length < 8) {
    alert(pwdReqs);
    return false;
  }
  if (!pwd.match(/[A-Z]/) || !/\d/.test(pwd)) {
    alert(pwdReqs);
    return false;
  }
  return true;
}

export default function Signup() {
  const [userEmail, setUserEmail] = useState('');
  const [userPass, setUserPass] = useState('');
  const [userPass2, setUserPass2] = useState('');
  const [buttonsDisabled, setButtonsDisabled] = useState(false);

  const navigate = useNavigate();
  const emailRegex = /[a-zA-Z0-9]+@[a-zA-Z]+\.[a-z]{2,3}/;

  const handleSignup = () => {
    setButtonsDisabled(true);

    const domain = userEmail.split('@')[1];
    if (!emailRegex.test(userEmail) || !allowed_domains.includes(domain)) {
      setButtonsDisabled(false);
      alert('Email Invalid');
      return;
    }

    if (userPass !== userPass2) {
      alert('Passwords do not match');
      setButtonsDisabled(false);
      return;
    }
    if (!isPasswordOk(userPass) || !isPasswordOk(userPass2)) {
      setButtonsDisabled(false);
      return;
    }

    createUserWithEmailAndPassword(auth, userEmail, userPass)
      .then(() => {
        sendEmailVerification(auth.currentUser).then(() => {
          alert('Please check your email for a verification link and return to sign-in.');
          navigate('/');
        });
      })
      .catch((error) => {
        alert('Unable to create user: ' + error.message);
      })
      .finally(() => {
        setButtonsDisabled(false);
      });
  };

  return (
    <div>
      <div id="loginBox" className="auth-box">
        <div className="logo-container">
          <span className="logo-text">TAX TITANS</span>
        </div>

        <form
          onSubmit={(e) => {
            e.preventDefault();
            handleSignup();
          }}
        >
          <div className="form-group">
            <label htmlFor="email">Email</label>
            <input
              onChange={(e) => setUserEmail(e.target.value)}
              name="email"
              type="email"
              placeholder="you@taxtitansusa.com"
              required
            />
          </div>

          <p className="form-hint">
            Password must be 8+ characters, with 1 capital letter and 1 number
          </p>

          <div className="form-group">
            <label htmlFor="pwd">Password</label>
            <input
              onChange={(e) => setUserPass(e.target.value)}
              name="pwd"
              type="password"
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="pwd2">Re-type Password</label>
            <input
              onChange={(e) => setUserPass2(e.target.value)}
              name="pwd2"
              type="password"
              required
            />
          </div>

          <div className="button-group">
            <button
              type="button"
              className="btn secondary-btn"
              disabled={buttonsDisabled}
              onClick={() => navigate(-1)}
            >
              Go Back
            </button>
            <button
              type="submit"
              className="btn primary-btn"
              disabled={buttonsDisabled}
            >
              Sign Up
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
